import React, { useState, forwardRef } from 'react';
import {
  Box,
  Grid,
  Typography,
  Divider,
  Button,
  useTheme,
} from '@mui/material';
import AgeQuantitySelector from '@shared/components/AgeQuantitySelector';
import GenericDropdown from '@shared/components/GenericDropdown';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HighlightoffIcon from '@mui/icons-material/HighlightOff';

const Passengers = forwardRef(
  (
    {
      passengersValue = 1, // número de adultos
      initialChilds = [], // array de menores
      setFlightClassOneWay,
      handleClose,
      initFlightClass,
      setSearchPax,
      setPaxError,
      paxError,
    },
    ref
  ) => {
    const theme = useTheme();
    const [flightClass, setFlightClass] = useState(initFlightClass ?? 1);
    const [paxWarning, setPaxWarning] = useState(null);

    const flightClasses = [
      { id: 1, fragments: [{ text: 'Economy' }] },
      { id: 4, fragments: [{ text: 'Premium Economy' }] },
      { id: 2, fragments: [{ text: 'Business' }] },
      { id: 5, fragments: [{ text: 'Premium Business' }] },
      { id: 3, fragments: [{ text: 'First' }] },
      { id: 6, fragments: [{ text: 'Premium First' }] },
    ];

    const handleChange = ({ adults, minors }) => {
      const infants = minors.filter(m => m.age < 2);
      const totalPax = adults + minors.length;

      if (totalPax >= 9) {
        setPaxWarning('Hasta 9 personas por reserva');
      } else {
        setPaxWarning(null);
      }
      if (infants.length > adults) {
        setPaxError('Máximo 1 infante por adulto');
      } else {
        setPaxError(null);
      }
      const childs = minors.map(({ age }) => ({ age }));
      setSearchPax({ adults, childs });
    };

    return (
      <Box
        ref={ref}
        sx={{
          minWidth: '330px',
          maxWidth: '100%',
          overflow: 'visible',
          backgroundColor: 'white',
        }}
      >
        {/* Selector de pasajeros */}
        <AgeQuantitySelector
          defaultAdults={passengersValue}
          defaultMinors={initialChilds}
          onChange={handleChange}
          totalLimit={9}
        />
        {paxError && (
          <Typography
            sx={{
              fontSize: 14,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              pl: 1,
              pt: 1,
              color: 'red',
            }}
          >
            <HighlightoffIcon sx={{ fontSize: 18 }} color={'red'} />
            {paxError}
          </Typography>
        )}

        {paxWarning && (
          <Typography
            sx={{
              fontSize: 14,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              pl: 1,
              pt: 1,
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 18 }} />
            {paxWarning}
          </Typography>
        )}

        <Divider sx={{ width: '100%', my: 2 }} />

        {/* Selección de cabina */}
        <Grid container alignItems="center" spacing={1}>
          <Grid item xs={4}>
            <Typography variant="subtitle1">Cabina</Typography>
          </Grid>
          <Grid item xs={8}>
            <GenericDropdown
              items={flightClasses}
              selectedItem={flightClasses.find(cls => cls.id === flightClass)}
              onSelect={item => {
                setFlightClass(item.id);
                setFlightClassOneWay(item.id);
              }}
              buttonLabel=""
              id="flight-class-dropdown"
              hasArrow
              isPrimaryBorder
              formControlHeight={40}
              menuItemHeight={38}
            />
          </Grid>
        </Grid>

        <Divider sx={{ width: '100%', my: 2 }} />

        {/* Botón aplicar */}
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="contained"
            fullWidth
            onClick={handleClose}
            sx={{
              fontWeight: 600,
              bgcolor: theme.primary,
              color: theme.text1,
              '&:hover': {
                bgcolor: theme.primary,
                color: theme.text1,
                opacity: 0.9,
              },
            }}
          >
            Aplicar
          </Button>
        </Box>
      </Box>
    );
  }
);

export default Passengers;
